
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1ad7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1ad7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $a2a2186cf7c778d6$exports = {};
$parcel$extendImportMap({
    "hVAk2": "arrow-check.d4bc1386.svg"
});

// import { initTestGame } from '../games/test_game.js';
const $b751604120426246$export$2c7b355bf3ba0505 = ()=>{
    const container = document.querySelector('.game-id_1'); // Ensure this matches your HTML
    const html = `
      <h2 class="leap-year-title">\u{41F}\u{435}\u{440}\u{435}\u{432}\u{456}\u{440} \u{432} \u{44F}\u{43A}\u{438}\u{439} \u{440}\u{456}\u{43A} \u{442}\u{438} \u{43D}\u{430}\u{440}\u{43E}\u{434}\u{438}\u{432}\u{441}\u{44F}</h2>
      <div class="leap-year-box">
        <div class="leap-year-input-wrapper">
          <input class="leap-year-input" placeholder="\u{412}\u{432}\u{435}\u{434}\u{456}\u{442}\u{44C} \u{440}\u{456}\u{43A} \u{43D}\u{430}\u{440}\u{43E}\u{434}\u{436}\u{435}\u{43D}\u{43D}\u{44F}" />
        </div>
        <h3 class="leap-year-result"></h3>
      </div>
  `;
    container.innerHTML = html;
    const input = container.querySelector('.leap-year-input');
    const result = container.querySelector('.leap-year-result');
    input.addEventListener('input', (event)=>{
        const year = Number(event.target.value);
        if (year === 0) {
            result.textContent = '';
            return;
        }
        if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
            result.textContent = "\u0412\u0438 \u043D\u0430\u0440\u043E\u0434\u0438\u043B\u0438\u0441\u044F \u0443 \u0432\u0438\u0441\u043E\u043A\u043E\u0441\u043D\u0438\u0439 \u0440\u0456\u043A!";
            result.style.color = "var(--colorCorrect)";
        } else {
            result.textContent = "\u0412\u0438 \u043D\u0430\u0440\u043E\u0434\u0438\u043B\u0438\u0441\u044F \u043D\u0435 \u0443 \u0432\u0438\u0441\u043E\u043A\u043E\u0441\u043D\u0438\u0439 \u0440\u0456\u043A.";
            result.style.color = "var(--colorIncorrect)";
        }
    });
};


var $1eb5f8cc5b353d2d$exports = {};
const $1eb5f8cc5b353d2d$var$initGuessNumberGame = ()=>{
    const container = document.querySelector('.game-id_2');
    const html = `
        <h2 class="guess-title">\u{412}\u{433}\u{430}\u{434}\u{430}\u{439} \u{447}\u{438}\u{441}\u{43B}\u{43E}, \u{44F}\u{43A}\u{435} \u{437}\u{430}\u{433}\u{430}\u{434}\u{430}\u{432} \u{43A}\u{43E}\u{43C}\u{43F}\u{2019}\u{44E}\u{442}\u{435}\u{440}</h2>
        <div class="guess-box">
          <div class="guess-input-wrapper">
            <input
              class="guess-input"
              placeholder="\u{412}\u{432}\u{435}\u{434}\u{456}\u{442}\u{44C} \u{447}\u{438}\u{441}\u{43B}\u{43E}"
              id="number"
            />
          </div>
          <label for="number"></label>
          <h3 class="guess-subtitle"></h3>
        </div>
  `;
    container.innerHTML = html;
    const input = container.querySelector('.guess-input');
    const subtitle = container.querySelector('.guess-subtitle');
    const secretNumber = Math.floor(Math.random() * 100) + 1;
    const handleGuess = (event)=>{
        const value = Number(event.target.value);
        if (value === secretNumber) subtitle.textContent = `\u{412}\u{456}\u{442}\u{430}\u{44E}, \u{432}\u{438} \u{432}\u{433}\u{430}\u{434}\u{430}\u{43B}\u{438} \u{447}\u{438}\u{441}\u{43B}\u{43E}! (${secretNumber})`;
        else if (value > secretNumber) subtitle.textContent = "\u0417\u0430\u043D\u0430\u0434\u0442\u043E \u0432\u0435\u043B\u0438\u043A\u0435 \u0447\u0438\u0441\u043B\u043E";
        else subtitle.textContent = "\u0417\u0430\u043D\u0430\u0434\u0442\u043E \u043C\u0430\u043B\u0435 \u0447\u0438\u0441\u043B\u043E";
    };
    input.addEventListener('input', handleGuess);
};
document.addEventListener('DOMContentLoaded', $1eb5f8cc5b353d2d$var$initGuessNumberGame);


const $3ad2cc8a66094144$export$73b3f4398c55f578 = ()=>{
    const gameContainer = document.querySelector('.game-id_3');
    let computerScore = 0;
    let playerScore = 0;
    let playerChoice = '';
    const choices = [
        'rock',
        'scissors',
        'paper'
    ];
    const gameHTML = `
  <div class="container rps-container">
  <h2 class="rps-title">\u{41A}\u{430}\u{43C}\u{456}\u{43D}\u{44C} - \u{43D}\u{43E}\u{436}\u{438}\u{446}\u{456} - \u{43F}\u{430}\u{43F}\u{456}\u{440}</h2>
  <div class="rps-gameplay">
    <ul class="rps-list">
      <li class="rps-item">
        <button class="rps-button__option rock" data-choice="rock"></button>
      </li>
      <li class="rps-item">
        <button
          class="rps-button__option scissors"
          data-choice="scissors"
        ></button>
      </li>
      <li class="rps-item">
        <button class="rps-button__option paper" data-choice="paper"></button>
      </li>
    </ul>
    <ul class="rps-score">
      <li class="rps-item__score">\u{420}\u{430}\u{445}\u{443}\u{43D}\u{43E}\u{43A}:</li>
      <li class="rps-item__score" id="cpu-score">
        \u{41A}\u{43E}\u{43C}\u{43F}\u{2019}\u{44E}\u{442}\u{435}\u{440} - ${computerScore}
      </li>
      <li class="rps-item__score" id="player-score">\u{412}\u{438} - ${playerScore}</li>
    </ul>
  </div>
  <p class="rps-text">\u{417}\u{440}\u{43E}\u{431}\u{456}\u{442}\u{44C} \u{441}\u{432}\u{456}\u{439} \u{432}\u{438}\u{431}\u{456}\u{440}!</p>
  <button class="rps-button">\u{412}\u{430}\u{440}\u{456}\u{430}\u{43D}\u{442} \u{43A}\u{43E}\u{43C}\u{43F}\u{2019}\u{44E}\u{442}\u{435}\u{440}\u{430}</button>
</div>
`;
    gameContainer.innerHTML = gameHTML;
    const resultText = gameContainer.querySelector('.rps-text');
    const cpuScoreElement = gameContainer.querySelector('#cpu-score');
    const playerScoreElement = gameContainer.querySelector('#player-score');
    const optionButtons = gameContainer.querySelectorAll('.rps-button__option');
    const playButton = gameContainer.querySelector('.rps-button');
    const handlePlayerChoice = (event)=>{
        playerChoice = event.target.dataset.choice;
        optionButtons.forEach((btn)=>btn.classList.remove('rps-button__option--active'));
        const parentLi = event.target;
        parentLi.classList.add('rps-button__option--active');
    };
    const handlePlayClick = (event)=>{
        const computerChoice = choices[Math.floor(Math.random() * choices.length)];
        if (playerChoice === 'rock' && computerChoice === 'rock') {
            resultText.textContent = "\u041D\u0456\u0447\u0438\u044F \u0432 \u0446\u044C\u043E\u043C\u0443 \u0440\u0430\u0443\u043D\u0434\u0456!";
            resultText.style.color = '#000000';
        } else if (playerChoice === 'rock' && computerChoice === 'scissors') {
            playerScore++;
            resultText.textContent = "\u0412\u0438 \u0432\u0438\u0433\u0440\u0430\u043B\u0438 \u0440\u0430\u0443\u043D\u0434!";
            resultText.style.color = '#039900';
        } else if (playerChoice === 'rock' && computerChoice === 'paper') {
            computerScore++;
            resultText.textContent = "\u041A\u043E\u043C\u043F\u2019\u044E\u0442\u0435\u0440 \u0432\u0438\u0433\u0440\u0430\u0432 \u0440\u0430\u0443\u043D\u0434!";
            resultText.style.color = '#990000';
        }
        if (playerChoice === 'scissors' && computerChoice === 'scissors') {
            resultText.textContent = "\u041D\u0456\u0447\u0438\u044F \u0432 \u0446\u044C\u043E\u043C\u0443 \u0440\u0430\u0443\u043D\u0434\u0456!";
            resultText.style.color = '#000000';
        } else if (playerChoice === 'scissors' && computerChoice === 'paper') {
            playerScore++;
            resultText.textContent = "\u0412\u0438 \u0432\u0438\u0433\u0440\u0430\u043B\u0438 \u0440\u0430\u0443\u043D\u0434!";
            resultText.style.color = '#039900';
        } else if (playerChoice === 'scissors' && computerChoice === 'rock') {
            computerScore++;
            resultText.textContent = "\u041A\u043E\u043C\u043F\u2019\u044E\u0442\u0435\u0440 \u0432\u0438\u0433\u0440\u0430\u0432 \u0440\u0430\u0443\u043D\u0434!";
            resultText.style.color = '#990000';
        }
        if (playerChoice === 'paper' && computerChoice === 'paper') {
            resultText.textContent = "\u041D\u0456\u0447\u0438\u044F \u0432 \u0446\u044C\u043E\u043C\u0443 \u0440\u0430\u0443\u043D\u0434\u0456!";
            resultText.style.color = '#000000';
        } else if (playerChoice === 'paper' && computerChoice === 'rock') {
            playerScore++;
            resultText.textContent = "\u0412\u0438 \u0432\u0438\u0433\u0440\u0430\u043B\u0438 \u0440\u0430\u0443\u043D\u0434!";
            resultText.style.color = '#039900';
        } else if (playerChoice === 'paper' && computerChoice === 'scissors') {
            computerScore++;
            resultText.textContent = "\u041A\u043E\u043C\u043F\u2019\u044E\u0442\u0435\u0440 \u0432\u0438\u0433\u0440\u0430\u0432 \u0440\u0430\u0443\u043D\u0434!";
            resultText.style.color = '#990000';
        }
        playerChoice = '';
        cpuScoreElement.textContent = `\u{41A}\u{43E}\u{43C}\u{43F}'\u{44E}\u{442}\u{435}\u{440} - ${computerScore}`;
        playerScoreElement.textContent = `\u{412}\u{438} - ${playerScore}`;
    };
    playButton.addEventListener('click', handlePlayClick);
    optionButtons.forEach((button)=>{
        button.addEventListener('click', handlePlayerChoice);
    });
};


const $79a36447900b2500$export$5d9c4c45c0c883c0 = ()=>{
    const gameContainer = document.querySelector('.game-id_4');
    const gameHTML = `<h2 class="calculator__title">\u{41A}\u{430}\u{43B}\u{44C}\u{43A}\u{443}\u{43B}\u{44F}\u{442}\u{43E}\u{440}</h2>
        <div class="calculator__game">
          <input class="number number__first" type="number" placeholder="\u{412}\u{432}\u{435}\u{434}\u{456}\u{442}\u{44C} \u{447}\u{438}\u{441}\u{43B}\u{43E}"/>
          <div class="calculator__actions">
            <button class="action" data-action="add">+</button>
            <button class="action" data-action="mul">*</button>
            <button class="action" data-action="sub">-</button>
            <button class="action" data-action="div">/</button>
          </div>
          <input class="number numbe__second" type="number" placeholder="\u{412}\u{432}\u{435}\u{434}\u{456}\u{442}\u{44C} \u{447}\u{438}\u{441}\u{43B}\u{43E}"/>
          <button class="calculate">=</button>
          <p class="result">\u{420}\u{435}\u{437}\u{443}\u{43B}\u{44C}\u{442}\u{430}\u{442}</p>
        </div>`;
    gameContainer.innerHTML = gameHTML;
    //logic
    const firstInput = document.querySelector('.number__first');
    const secondInput = document.querySelector('.numbe__second');
    const actions = document.querySelector('.calculator__actions');
    const calculate = document.querySelector('.calculate');
    const result = document.querySelector('.result');
    // ~~~
    let currentAction = '';
    let res = 0;
    const handleChooseAction = (event)=>{
        document.querySelectorAll('.action').forEach((btn)=>{
            btn.classList.remove('choose');
        });
        event.target.classList.add('choose');
        currentAction = event.target.dataset.action;
    };
    const handleCalculate = (event)=>{
        res = 0;
        const firstNumber = Number(firstInput.value);
        const secondNumber = Number(secondInput.value);
        console.log(firstNumber);
        switch(currentAction){
            case 'add':
                res = firstNumber + secondNumber;
                result.textContent = res;
                break;
            case 'mul':
                res = firstNumber * secondNumber;
                result.textContent = res;
                break;
            case 'sub':
                res = firstNumber - secondNumber;
                result.textContent = res;
                break;
            case 'div':
                if (secondNumber === 0) result.textContent = "\u041D\u0430 0 \u0434\u0456\u043B\u0438\u0442\u0438 \u043D\u0435 \u043C\u043E\u0436\u043D\u0430";
                else {
                    res = firstNumber / secondNumber;
                    if (res % 1 === 0) result.textContent = res;
                    else result.textContent = res.toFixed(2);
                }
                break;
            default:
                break;
        }
    };
    actions.addEventListener('click', handleChooseAction);
    calculate.addEventListener('click', handleCalculate);
};


const $6f32b9a8f1eafac4$export$b722dc28c4057a09 = ()=>{
    const gameContainer = document.querySelector('.game-id_5');
    const gameHTML = `<h2 class="time-\u{441}alculator__title">\u{41A}\u{430}\u{43B}\u{44C}\u{43A}\u{443}\u{43B}\u{44F}\u{442}\u{43E}\u{440} \u{447}\u{430}\u{441}\u{443}</h2>
        <div class="time-calculator__game">
          <div class="time-calculator__input-container">
              <input class="time-calculator__input" data-input type="number" placeholder="\u{412}\u{432}\u{435}\u{434}\u{456}\u{442}\u{44C} \u{447}\u{438}\u{441}\u{43B}\u{43E}"/>
              <button class="time-calculator__button" data-button ></button>
          </div>
          <p class="time-calculator__result" data-result >0 \u{434}\u{43D}. 00:00:00</p>
        </div>`;
    gameContainer.innerHTML = gameHTML;
    //logic
    const input = document.querySelector("[data-input]");
    const button = document.querySelector("[data-button]");
    const result = document.querySelector("[data-result]");
    button.addEventListener("click", ()=>{
        let seconds = Number(input.value);
        const days = Math.floor(seconds / 86400);
        seconds %= 86400;
        const hours = Math.floor(seconds / 3600);
        seconds %= 3600;
        const minutes = Math.floor(seconds / 60);
        seconds %= 60;
        const time = (num)=>String(num).padStart(2, '0');
        result.textContent = `${days} \u{434}\u{43D}. ${time(hours)}:${time(minutes)}:${time(seconds)}`;
    });
};


const $3983f2835971aaf4$export$d3b0f780bd4609ef = ()=>{
    const gameContainer = document.querySelector('.game-id_6');
    class DinosaurGame {
        constructor(dinosaur, gameArea){
            this.dinosaur = dinosaur;
            this.gameArea = gameArea;
            this.gameOver = false;
            this.isJumping = false;
            this.gameModalStart();
        }
        init() {
            document.addEventListener('keydown', (event)=>{
                if (event.code === 'Space' && !this.gameOver && !this.isJumping) {
                    event.preventDefault();
                    this.jump();
                }
            });
            this.gameArea.addEventListener('mousedown', (event)=>{
                if (!this.gameOver && !this.isJumping) {
                    event.preventDefault();
                    this.jump();
                }
            });
            this.renderObstacles();
            this.checkCollision();
            this.move();
        }
        move() {
            this.dinosaur.classList.add('move');
            this.gameArea.classList.add('move');
            if (!this.gameOver) {
                this.dinosaur.style.animationPlayState = 'running';
                this.gameArea.style.animationPlayState = 'running';
            }
        }
        jump() {
            this.isJumping = true;
            this.dinosaur.classList.add('jump');
            setTimeout(()=>{
                this.isJumping = false;
                this.dinosaur.classList.remove('jump');
            }, 600);
        }
        randomCactuses() {
            const randomNum = Math.floor(Math.random() * 11);
            const obstacle = this.gameArea.querySelector('.cactus');
            if (randomNum >= 8) obstacle.classList.add('cactuses');
            else if (randomNum >= 5 && randomNum <= 7) obstacle.classList.add('cactus--one');
            else if (randomNum >= 2 && randomNum <= 4) obstacle.classList.add('cactuses--two');
            else if (randomNum <= 1) obstacle.classList.add('cactuses--small');
        }
        renderObstacles() {
            const obstacle = document.createElement('div');
            obstacle.classList.add('cactus');
            this.gameArea.appendChild(obstacle);
            this.randomCactuses();
            const handleAnimation = ()=>{
                obstacle.removeEventListener('animationend', handleAnimation);
                obstacle.remove();
                if (!this.gameOver) this.renderObstacles();
            };
            obstacle.addEventListener('animationend', handleAnimation);
        }
        checkCollision() {
            const gameProcess = ()=>{
                if (this.gameOver === true) return;
                const obstacle = this.gameArea.querySelector('.cactus');
                const obstacleRect = obstacle.getBoundingClientRect();
                const dinosaurRect = this.dinosaur.getBoundingClientRect();
                if (dinosaurRect.right > obstacleRect.left && dinosaurRect.left < obstacleRect.right && dinosaurRect.bottom > obstacleRect.top) {
                    this.endGame(obstacle);
                    return;
                }
                requestAnimationFrame(gameProcess);
            };
            requestAnimationFrame(gameProcess);
        }
        endGame(obstacle) {
            this.dinosaur.style.animationPlayState = 'paused';
            this.gameArea.style.animationPlayState = 'paused';
            obstacle.style.animationPlayState = 'paused';
            this.gameOver = true;
            this.gameOverModal();
        }
        createModal(msg, btnText, btnCallback) {
            const modalHtml = `
      <div class="dinosaur__modal">
        <p class="dinosaur__message">${msg}</p>
        <button class="dinosaur__start button">${btnText}</button>
      </div>`;
            this.gameArea.insertAdjacentHTML('beforeend', modalHtml);
            const modal = this.gameArea.querySelector('.dinosaur__modal');
            modal.classList.add('show');
            const retryBtn = this.gameArea.querySelector('.dinosaur__start');
            retryBtn.addEventListener('click', btnCallback);
        }
        gameModalStart() {
            this.createModal("\u0417\u0456\u0433\u0440\u0430\u0454\u043C\u043E?", "\u041F\u043E\u0447\u0430\u0442\u0438 \u0433\u0440\u0443", ()=>{
                const modal = this.gameArea.querySelector('.dinosaur__modal');
                modal.classList.remove('show');
                setTimeout(()=>{
                    modal.remove();
                }, 250);
                this.init();
            });
        }
        gameOverModal() {
            this.createModal('GAME OVER!', "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0437\u043D\u043E\u0432\u0443", ()=>this.restartGame());
        }
        restartGame() {
            this.gameArea.querySelector('.dinosaur__modal').remove();
            this.gameArea.querySelector('.cactus').remove();
            this.gameOver = false;
            this.renderObstacles();
            this.checkCollision();
            this.move();
        }
    }
    const gameHTML = `
    <h2 class="dinosaur__title">Google \u{434}\u{438}\u{43D}\u{43E}\u{437}\u{430}\u{432}\u{440}</h2>
    <div class="dinosaur__game">
      <div class="dinosaur"></div>
    </div>`;
    gameContainer.innerHTML = gameHTML;
    const dinosaur = gameContainer.querySelector('.dinosaur');
    const gameArea = document.querySelector('.dinosaur__game');
    new DinosaurGame(dinosaur, gameArea);
//logic
};


const $016cda2355d94864$export$73d110a368e7c85c = ()=>{
    const gameContainer = document.querySelector('.game-id_7');
    const gameHTML = `<h2 class="football__title">\u{424}\u{443}\u{442}\u{431}\u{43E}\u{43B}</h2>
        </article>
            <div class="field" data-field>
                <div class="ball" data-ball ></div>
            </div>`;
    gameContainer.innerHTML = gameHTML;
    //logic
    const field = document.querySelector("[data-field]");
    const ball = document.querySelector("[data-ball]");
    field.addEventListener("click", (event)=>{
        console.log(event);
        const x = event.offsetX - 25;
        const y = event.offsetY - 25;
        ball.style.left = x + "px";
        ball.style.top = y + "px";
        ball.classList.add("active");
        setTimeout(()=>{
            ball.classList.remove("active");
        }, 300);
    });
};


const $159c4e56aebd8cbf$export$2b88251244784b7a = ()=>{
    const gameContainer = document.querySelector('.game-id_8');
    //==========================
    const gameHTML = `  <div class="biggest-num__container">
    <h2 class="biggest-num__title">\u{412}\u{432}\u{435}\u{434}\u{456}\u{442}\u{44C} 3 \u{447}\u{438}\u{441}\u{43B}\u{430}</h2>
      <ul class="biggest-num__list">
      <li class="biggest-num__item">
        <label for="biggest-num__input--one">
          <input
            class="num biggest-num__input"
            type="text"
            id="biggest-num__input--one"
              placeholder="\u{412}\u{432}\u{435}\u{434}\u{456}\u{442}\u{44C} \u{447}\u{438}\u{441}\u{43B}\u{43E}"
          />
        </label>
      </li>
      <li class="biggest-num__item">
        <label for="biggest-num__input--two">
          <input
            class="num biggest-num__input"
            type="text"
            id="biggest-num__input--two"
              placeholder="\u{412}\u{432}\u{435}\u{434}\u{456}\u{442}\u{44C} \u{447}\u{438}\u{441}\u{43B}\u{43E}"
          />
        </label>
      </li>
      <li class="biggest-num__item">
        <label for="biggest-num__input--three">
          <input

            class="num biggest-num__input"
            type="text"
            id="biggest-num__input--three"
              placeholder="\u{412}\u{432}\u{435}\u{434}\u{456}\u{442}\u{44C} \u{447}\u{438}\u{441}\u{43B}\u{43E}"
          />
        </label>
      </li>
    </ul>
<p class="biggest-num__text">\u{41D}\u{430}\u{439}\u{431}\u{456}\u{43B}\u{44C}\u{448}\u{435} \u{447}\u{438}\u{441}\u{43B}\u{43E}, \u{44F}\u{43A}\u{435} \u{432}\u{438} \u{432}\u{432}\u{435}\u{43B}\u{438} - (<span class="biggest-num__text--part">\u{447}\u{438}\u{441}\u{43B}\u{43E}</span>)</p>      </div>`;
    gameContainer.innerHTML = gameHTML;
    // logik
    const numOne = document.querySelector('#biggest-num__input--one');
    const numTwo = document.querySelector('#biggest-num__input--two');
    const numThree = document.querySelector('#biggest-num__input--three');
    const biggestNum = document.querySelector('.biggest-num__text--part');
    const handleLogik = ()=>{
        const arrNums = [
            Number(numOne.value),
            Number(numTwo.value),
            Number(numThree.value)
        ];
        let num = arrNums[0];
        for(let i = 0; i < arrNums.length; i++)if (arrNums[i] > num) num = arrNums[i];
        biggestNum.textContent = `${num === 0 ? "\u0447\u0438\u0441\u043B\u043E" : num}`;
    };
    //==========================
    numOne.addEventListener('input', handleLogik);
    numTwo.addEventListener('input', handleLogik);
    numThree.addEventListener('input', handleLogik);
};


const $982f26c643a4c517$export$be82222ae397b234 = ()=>{
    const gameContainer = document.querySelector('.game-id_9');
    //==========================
    const gameHTML = `
  <h2 class="swiper__title">\u{41D}\u{430}\u{448}\u{430} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{430}</h2>
<div class="swiper">
  <div class="swiper-wrapper">
    <div class="swiper-slide">
      <div class="content content__danya">
        <div class="content__photo content__photo--danya">
        </div>
        <p class="content__name">\u{414}\u{430}\u{43D}\u{44F}</p>
        <p class="content__worked">\u{41B}\u{456}\u{434}\u{435}\u{440} \u{43D}\u{430}\u{448}\u{43E}\u{457} \u{43A}\u{43E}\u{43C}\u{430}\u{43D}\u{434}\u{438}</p>
      </div>
    </div>

    <div class="swiper-slide">
      <div class="content content">
        <div class="content__photo content__photo--ann">
        </div>
        <p class="content__name">\u{410}\u{43D}\u{43D}\u{430}</p>
        <p class="content__worked">\u{41D}\u{430}\u{448} \u{441}\u{43A}\u{440}\u{430}\u{43C} \u{43C}\u{430}\u{439}\u{441}\u{442}\u{435}\u{440}</p>
      </div>
    </div>

    <div class="swiper-slide">
      <div class="content">
        <div class="content__photo content__photo--filip">
        </div>
        <p class="content__name">\u{424}\u{456}\u{43B}\u{456}\u{43F}</p>
        <p class="content__worked">\u{417}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{438}\u{439} \u{440}\u{43E}\u{437}\u{440}\u{43E}\u{431}\u{43D}\u{438}\u{43A}</p>
      </div>
    </div>

    <div class="swiper-slide">
      <div class="content content">
        <div class="content__photo content__photo--Artem">
        </div>
        <p class="content__name">\u{410}\u{440}\u{442}\u{435}\u{43C}</p>
        <p class="content__worked">\u{417}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{438}\u{439} \u{440}\u{43E}\u{437}\u{440}\u{43E}\u{431}\u{43D}\u{438}\u{43A}</p>
      </div>
    </div>

    <div class="swiper-slide">
      <div class="content">
        <div class="content__photo content__photo--andrew">

        </div>
        <p class="content__name">\u{410}\u{43D}\u{434}\u{440}\u{456}\u{439}</p>
        <p class="content__worked">\u{417}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{438}\u{439} \u{440}\u{43E}\u{437}\u{440}\u{43E}\u{431}\u{43D}\u{438}\u{43A}</p>
      </div>
    </div>

    <div class="swiper-slide">
      <div class="content content">
        <div class="content__photo content__photo--vlad">
        </div>
        <p class="content__name ">\u{412}\u{43B}\u{430}\u{434}</p>
        <p class="content__worked">\u{417}\u{432}\u{438}\u{447}\u{430}\u{439}\u{43D}\u{438}\u{439} "\u{440}\u{43E}\u{437}\u{440}\u{43E}\u{431}\u{43D}\u{438}\u{43A}"</p>
      </div>
    </div>
  </div>

  <div class="swiper-button-prev swiper-button" id="swiper-button-prev" data-swiper="left"></div>
  <div class="swiper-button-next swiper-button" id="swiper-button-next" data-swiper="right"></div>
  <div class="swiper-pagination"></div>
</div>
    `;
    gameContainer.innerHTML = gameHTML;
    const swiper = new Swiper('.swiper', {
        effect: 'creative',
        creativeEffect: {
            prev: {
                translate: [
                    '-80%',
                    0,
                    0
                ],
                scale: 0.5
            },
            next: {
                translate: [
                    '80%',
                    0,
                    0
                ],
                scale: 0.5
            }
        },
        loop: true,
        slidesPerView: 3,
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            320: {
                slidesPerView: 1
            }
        }
    });
    const switcher = document.querySelector('.switcher');
    const swiperButtonLeft = document.querySelector(`[data-swiper="left"]`);
    const swiperButtonRight = document.querySelector(`[data-swiper="right"]`);
    const handleSwitcher = (event)=>{
        if (event.target.checked) {
            swiperButtonLeft.classList.add('dark');
            swiperButtonRight.classList.add('dark');
        } else {
            swiperButtonLeft.classList.remove('dark');
            swiperButtonRight.classList.remove('dark');
        }
    };
    switcher.addEventListener('change', handleSwitcher);
};


const $bf9a6041816ebbc2$export$841defb1c455aaa4 = ()=>{
    const container = document.querySelector('.game-id_10');
    const html = `
   <h3 class="scientists-title">\u{41E}\u{431}\u{435}\u{440}\u{438} \u{432}\u{447}\u{435}\u{43D}\u{43E}\u{433}\u{43E}/\u{438}\u{445}</h3>

     <ul class="scientists-cards">
       <li class="scientists-card-item"><div class="scientist-name">Albert Einstein 1879-1955</div></li>
       <li class="scientists-card-item"><div class="scientist-name">Isaac Newton 1643-1727</div></li>
       <li class="scientists-card-item"><div class="scientist-name">Galileo Galilei 1564-1642</div></li>
       <li class="scientists-card-item"><div class="scientist-name">Marie Curie 1867-1934</div></li>
       <li class="scientists-card-item"><div class="scientist-name">Nicolaus Copernicus 1473-1543</div></li>
       <li class="scientists-card-item"><div class="scientist-name">Charles Darwin 1809-1882</div></li>
       <li class="scientists-card-item"><div class="scientist-name">Stephen Hawking 1942-2018</div></li>
       <li class="scientists-card-item"><div class="scientist-name">Carl Sagan 1934-1996</div></li>
       <li class="scientists-card-item"><div class="scientist-name">Ada Lovelace 1815-1852</div></li>
       <li class="scientists-card-item"><div class="scientist-name">Alan Turing 1912-1954</div></li>
       <li class="scientists-card-item"><div class="scientist-name">Sofia Kovalevskaya 1850-1891</div></li>
       <li class="scientists-card-item"><div class="scientist-name">Michael Faraday 1791-1867</div></li>
     </ul>

     <ul class="scientists-tasks">
       <li class="scientists-item scientists-item--odd"><button id="btn-born19" class="scientists-btn scientists-btn--odd">\u{42F}\u{43A}\u{456} \u{432}\u{447}\u{435}\u{43D}\u{456} \u{43D}\u{430}\u{440}\u{43E}\u{434}\u{438}\u{43B}\u{438}\u{441}\u{44F} \u{432} 19 \u{441}\u{442}.</button></li>
              <li class="scientists-item scientists-item--even"><button id="btn-einstein" class="scientists-btn scientists-btn--even">\u{417}\u{43D}\u{430}\u{439}\u{442}\u{438} \u{440}\u{456}\u{43A} \u{43D}\u{430}\u{440}\u{43E}\u{434}\u{436}\u{435}\u{43D}\u{43D}\u{44F} Albert Einstein</button></li>
       <li class="scientists-item scientists-item--odd"><button id="btn-sortAlphabet" class="scientists-btn scientists-btn--odd">\u{412}\u{456}\u{434}\u{441}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{442}\u{438} \u{432}\u{447}\u{435}\u{43D}\u{438}\u{445} \u{437}\u{430} \u{430}\u{43B}\u{444}\u{430}\u{432}\u{456}\u{442}\u{43E}\u{43C}</button></li>
              <li class="scientists-item scientists-item--even"><button id="btn-lastNameC" class="scientists-btn scientists-btn--c scientists-btn--even">\u{417}\u{43D}\u{430}\u{439}\u{442}\u{438} \u{432}\u{447}\u{435}\u{43D}\u{438}\u{445}, \u{43F}\u{440}\u{456}\u{437}\u{432}\u{438}\u{449}\u{430} \u{44F}\u{43A}\u{438}\u{445} \u{43F}\u{43E}\u{447}\u{438}\u{43D}\u{430}\u{44E}\u{442}\u{44C}\u{441}\u{44F} \u{43D}\u{430} \u{43D}\u{430} \u{43B}\u{456}\u{442}\u{435}\u{440}\u{443} \u{201C}\u{421}\u{201D} </button></li>
       <li class="scientists-item scientists-item--odd"><button id="btn-sortLifespan" class="scientists-btn scientists-btn--odd">\u{412}\u{456}\u{434}\u{441}\u{43E}\u{440}\u{442}\u{443}\u{432}\u{430}\u{442}\u{438} \u{432}\u{447}\u{435}\u{43D}\u{438}\u{445} \u{437}\u{430} \u{43A}\u{456}\u{43B}\u{44C}\u{43A}\u{456}\u{441}\u{442}\u{44E} \u{43F}\u{440}\u{43E}\u{436}\u{438}\u{442}\u{438}\u{445} \u{440}\u{43E}\u{43A}\u{456}\u{432}</button></li>
              <li class="scientists-item scientists-item--even"><button id="btn-removeA" class="scientists-btn scientists-btn--even">\u{412}\u{438}\u{434}\u{430}\u{43B}\u{438}\u{442}\u{438} \u{432}\u{441}\u{456}\u{445} \u{432}\u{447}\u{435}\u{43D}\u{438}\u{445}, \u{456}\u{43C}\u{2019}\u{44F} \u{44F}\u{43A}\u{438}\u{445} \u{43F}\u{43E}\u{447}\u{438}\u{43D}\u{430}\u{454}\u{442}\u{44C}\u{441}\u{44F} \u{43D}\u{430} \u{201C}\u{410}\u{201D}</button></li>
       <li class="scientists-item scientists-item--odd"><button id="btn-latestBorn" class="scientists-btn scientists-btn--odd">\u{417}\u{43D}\u{430}\u{439}\u{442}\u{438} \u{432}\u{447}\u{435}\u{43D}\u{43E}\u{433}\u{43E}, \u{44F}\u{43A}\u{438}\u{439} \u{43D}\u{430}\u{440}\u{43E}\u{434}\u{438}\u{432}\u{441}\u{44F} \u{43D}\u{430}\u{439}\u{43F}\u{456}\u{437}\u{43D}\u{456}\u{448}\u{435}</button></li>
       <li class="scientists-item scientists-item--longshor scientists-item--even"><button id="btn-longShort" class="scientists-btn">\u{417}\u{43D}\u{430}\u{439}\u{442}\u{438} \u{432}\u{447}\u{435}\u{43D}\u{43E}\u{433}\u{43E}, \u{44F}\u{43A}\u{438}\u{439} \u{43F}\u{440}\u{43E}\u{436}\u{438}\u{432} \u{43D}\u{430}\u{439}\u{434}\u{43E}\u{432}\u{448}\u{435} \u{456} \u{432}\u{447}\u{435}\u{43D}\u{43E}\u{433}\u{43E}, 
\u{44F}\u{43A}\u{438}\u{439} \u{43F}\u{440}\u{43E}\u{436}\u{438}\u{432} \u{43D}\u{430}\u{439}\u{43C}\u{435}\u{43D}\u{448}\u{435}</button></li>
       <li class="scientists-item"><button id="btn-sameInitials" class="scientists-btn scientists-btn--1">1. \u{417}\u{43D}\u{430}\u{439}\u{442}\u{438} \u{432}\u{447}\u{435}\u{43D}\u{438}\u{445}, \u{432} \u{44F}\u{43A}\u{438}\u{445} \u{441}\u{43F}\u{456}\u{432}\u{43F}\u{430}\u{434}\u{430}\u{44E}\u{442}\u{44C} \u{43F}\u{435}\u{440}\u{448}\u{456} \u{43B}\u{456}\u{442}\u{435}\u{440}\u{438} \u{456}\u{43C}\u{435}\u{43D}\u{456} \u{456} \u{43F}\u{440}\u{456}\u{437}\u{432}\u{438}\u{449}\u{430}</button></li>
     </ul>
  `;
    container.innerHTML = html;
    const cardsContainer = container.querySelector('.scientists-cards');
    const getCards = ()=>Array.from(cardsContainer.querySelectorAll('.scientists-card-item'));
    const getBirth = (text)=>{
        const years = text.slice(text.length - 9);
        const year1 = years[0];
        const year2 = years[1];
        const year3 = years[2];
        const year4 = years[3];
        return (year1 + year2 + year3 + year4) * 1;
    };
    const getDeath = (text)=>{
        const years = text.slice(text.length - 9);
        const death1 = years[5];
        const death2 = years[6];
        const death3 = years[7];
        const death4 = years[8];
        return (death1 + death2 + death3 + death4) * 1;
    };
    const getLife = (text)=>getDeath(text) - getBirth(text);
    // =====================================================
    const btnBorn19 = container.querySelector('#btn-born19');
    const handleBorn19 = ()=>{
        const cards = getCards();
        const filtered = cards.filter((card)=>{
            const birth = getBirth(card.textContent);
            return birth >= 1801 && birth <= 1900;
        });
        cardsContainer.innerHTML = '';
        filtered.forEach((card)=>cardsContainer.appendChild(card));
    };
    btnBorn19.addEventListener('click', handleBorn19);
    // =====================================================
    const btnSortAlphabet = container.querySelector('#btn-sortAlphabet');
    const handleSortAlphabet = ()=>{
        const cards = getCards();
        const sorted = cards.sort((a, b)=>a.textContent.localeCompare(b.textContent));
        cardsContainer.innerHTML = '';
        sorted.forEach((card)=>cardsContainer.appendChild(card));
    };
    btnSortAlphabet.addEventListener('click', handleSortAlphabet);
    // =====================================================
    const btnSortLifespan = container.querySelector('#btn-sortLifespan');
    const handleSortLifespan = ()=>{
        const cards = getCards();
        const sorted = cards.sort((a, b)=>{
            return getLife(b.textContent) - getLife(a.textContent);
        });
        cardsContainer.innerHTML = '';
        sorted.forEach((card)=>cardsContainer.appendChild(card));
    };
    btnSortLifespan.addEventListener('click', handleSortLifespan);
    // =====================================================
    const btnLatestBorn = container.querySelector('#btn-latestBorn');
    const handleLatestBorn = ()=>{
        const cards = getCards();
        let latest = cards[0];
        cards.forEach((card)=>{
            if (getBirth(card.textContent) > getBirth(latest.textContent)) latest = card;
        });
        cardsContainer.innerHTML = '';
        cardsContainer.appendChild(latest);
    };
    btnLatestBorn.addEventListener('click', handleLatestBorn);
    // =====================================================
    const btnEinstein = container.querySelector('#btn-einstein');
    const handleEinstein = ()=>{
        const cards = getCards();
        let einsteinCard = null;
        cards.forEach((card)=>{
            if (card.textContent.indexOf('Albert Einstein') !== -1) einsteinCard = card;
        });
        if (einsteinCard !== null) {
            cardsContainer.innerHTML = '';
            cardsContainer.appendChild(einsteinCard);
        }
    };
    btnEinstein.addEventListener('click', handleEinstein);
    // =====================================================
    const btnLastNameC = container.querySelector('#btn-lastNameC');
    const handleLastNameC = ()=>{
        const cards = getCards();
        cards.forEach((card)=>{
            const parts = card.textContent.split(' ');
            const last = parts[1];
            if (last[0] !== 'C') card.remove();
        });
    };
    btnLastNameC.addEventListener('click', handleLastNameC);
    // =====================================================
    const btnRemoveA = container.querySelector('#btn-removeA');
    const handleRemoveA = ()=>{
        const cards = getCards();
        cards.forEach((card)=>{
            const first = card.textContent.split(' ')[0];
            if (first[0] === 'A') card.remove();
        });
    };
    btnRemoveA.addEventListener('click', handleRemoveA);
    // =====================================================
    const btnLongShort = container.querySelector('#btn-longShort');
    const handleLongShort = ()=>{
        const cards = getCards();
        let longest = cards[0];
        let shortest = cards[0];
        cards.forEach((card)=>{
            const life = getLife(card.textContent);
            if (life > getLife(longest.textContent)) longest = card;
            if (life < getLife(shortest.textContent)) shortest = card;
        });
        cardsContainer.innerHTML = '';
        cardsContainer.appendChild(longest);
        cardsContainer.appendChild(shortest);
    };
    btnLongShort.addEventListener('click', handleLongShort);
    // =====================================================
    const btnSameInitials = container.querySelector('#btn-sameInitials');
    const handleSameInitials = ()=>{
        const cards = getCards();
        cards.forEach((card)=>{
            const parts = card.textContent.split(' ');
            const first = parts[0][0];
            const last = parts[1][0];
            if (first !== last) card.remove();
        });
    };
    btnSameInitials.addEventListener('click', handleSameInitials);
};



const $d1aa1a428dc45cce$export$5b8d7e724d35520d = ()=>{
    const gameContainer = document.querySelector('.game-id_11');
    const gameHTML = `
            <h2 class="tone__title">\u{412}\u{433}\u{430}\u{434}\u{430}\u{439} \u{43A}\u{43E}\u{43B}\u{456}\u{440}</h2>
            <div class="tone__game">
              <div class="tone__colors">
                <div class="tone__box tone__box--current"></div>
                <div class="tone__box tone__box--user">
                  <p class="similarity"></p>
                  <div class="tone__controls">
                      <input
                        id="r"
                        class="tone__range tone__range--red"
                        type="range"
                        min="0"
                        max="255"
                        step="1"
                      />
                      <input
                        id="g"
                        class="tone__range tone__range--green"
                        type="range"
                        min="0"
                        max="255"
                        step="1"
                      />
                      <input
                        id="b"
                        class="tone__range tone__range--blue"
                        type="range"
                        min="0"
                        max="255"
                        step="1"
                      />
                  </div>
                  <div class="tone__meta">
                    <button class="tone__btn btn__done" type="button">
                    </button>
                    <button class="tone__btn btn__next is__closed" type="button">
                    </button>
                  </div>
                </div>
              </div>
            </div>`;
    gameContainer.innerHTML = gameHTML;
    //logic
    const control = document.querySelector('.tone__controls');
    const userBox = document.querySelector('.tone__box--user');
    const currentBox = document.querySelector('.tone__box--current');
    const btnDone = document.querySelector('.btn__done');
    const btnNext = document.querySelector('.btn__next');
    const btns = document.querySelector('.tone__meta');
    const similarity = document.querySelector('.similarity');
    const ranges = document.querySelectorAll('.tone__range');
    const handleChangeBtn = ()=>{
        btnDone.classList.toggle('is__closed');
        btnNext.classList.toggle('is__closed');
        control.classList.toggle('is__closed');
    };
    let arrCurrentColor = [];
    let currentBoxColor;
    let arrUserColor = [];
    const generatorColor = ()=>{
        const r = Math.floor(Math.random() * 255);
        const g = Math.floor(Math.random() * 255);
        const b = Math.floor(Math.random() * 255);
        arrCurrentColor = [
            r,
            g,
            b
        ];
        currentBoxColor = `rgb(${r}, ${g}, ${b})`;
        currentBox.style.backgroundColor = currentBoxColor;
    };
    const renderReferenceBox = ()=>{
        const referenceBox = document.createElement('div');
        referenceBox.classList.add('box__reference');
        referenceBox.style.backgroundColor = currentBoxColor;
        userBox.appendChild(referenceBox);
    };
    const handleChooseColor = ()=>{
        const red = document.querySelector('.tone__range--red').value;
        const green = document.querySelector('.tone__range--green').value;
        const blue = document.querySelector('.tone__range--blue').value;
        arrUserColor = [
            red,
            green,
            blue
        ];
        const userBoxColor = `rgb(${red}, ${green}, ${blue})`;
        userBox.style.backgroundColor = userBoxColor;
    };
    const getColorText = ()=>{
        if (arrUserColor[0] < 167 && arrUserColor[1] < 167 && arrUserColor[2] < 167) return 'var(--colorBgPrimary)';
        else return 'var(--colorTextPrimary)';
    };
    let interest = 0;
    const calc = (arrNum1, arrNum2)=>{
        let sumAllInterest = 0;
        for(let i = 0; i < 3; i++){
            const difference = Math.abs(arrNum1[i] - arrNum2[i]);
            const interestRight = 100 - difference * 100 / 255;
            sumAllInterest += interestRight;
        }
        interest = Math.floor(sumAllInterest / 3);
    };
    const handleComparison = ()=>{
        handleChooseColor();
        calc(arrCurrentColor, arrUserColor);
        similarity.style.color = getColorText();
        similarity.textContent = `${interest} %`;
        renderReferenceBox();
    };
    const restart = ()=>{
        generatorColor();
        const boxRef = userBox.querySelector('.box__reference');
        boxRef.remove();
        similarity.textContent = '';
        ranges.forEach((range)=>{
            range.value = 128;
        });
        userBox.style.backgroundColor = `rgb(128, 128, 128)`;
    };
    generatorColor();
    control.addEventListener('input', handleChooseColor);
    btnDone.addEventListener('click', handleComparison);
    btnNext.addEventListener('click', restart);
    btns.addEventListener('click', handleChangeBtn);
};


const $5ed35395810c1c9b$export$79863f625c4e57 = [
    {
        init: (0, $b751604120426246$export$2c7b355bf3ba0505),
        id: 1,
        name: "\u0412\u0438\u0441\u043E\u043A\u043E\u0441\u043D\u0438\u0439 \u043A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0442\u043E\u0440",
        category: 'numerical'
    },
    {
        init: (0, $1eb5f8cc5b353d2d$exports.initGuessNumberGame),
        id: 2,
        name: "\u0412\u0433\u0430\u0434\u0430\u0439 \u0447\u0438\u0441\u043B\u043E",
        category: 'numerical'
    },
    {
        init: (0, $3ad2cc8a66094144$export$73b3f4398c55f578),
        id: 3,
        name: "\u041A\u0430\u043C\u0456\u043D\u044C-\u041D\u043E\u0436\u0438\u0446\u0456-\u041F\u0430\u043F\u0456\u0440",
        category: 'game'
    },
    {
        init: (0, $79a36447900b2500$export$5d9c4c45c0c883c0),
        id: 4,
        name: "\u041A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0442\u043E\u0440",
        category: 'numerical'
    },
    {
        init: (0, $6f32b9a8f1eafac4$export$b722dc28c4057a09),
        id: 5,
        name: "\u041A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0442\u043E\u0440 \u0447\u0430\u0441\u0443",
        category: 'numerical'
    },
    {
        init: (0, $3983f2835971aaf4$export$d3b0f780bd4609ef),
        id: 6,
        name: "Google \u0434\u0438\u043D\u043E\u0437\u0430\u0432\u0440\u0438\u043A",
        category: 'game'
    },
    {
        init: (0, $016cda2355d94864$export$73d110a368e7c85c),
        id: 7,
        name: "\u0424\u0443\u0442\u0431\u043E\u043B",
        category: 'game'
    },
    {
        init: (0, $159c4e56aebd8cbf$export$2b88251244784b7a),
        id: 8,
        name: "\u041D\u0430\u0439\u0431\u0456\u043B\u044C\u0448\u0435 \u0447\u0438\u0441\u043B\u043E",
        category: 'numerical'
    },
    {
        init: (0, $982f26c643a4c517$export$be82222ae397b234),
        id: 9,
        name: "\u041D\u0430\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430",
        category: 'acquaintance'
    },
    {
        init: (0, $bf9a6041816ebbc2$export$841defb1c455aaa4),
        id: 10,
        name: "\u0412\u0447\u0435\u043D\u0438\u0439",
        category: 'acquaintance'
    },
    {
        init: (0, $d1aa1a428dc45cce$export$5b8d7e724d35520d),
        id: 11,
        name: "\u0412\u0433\u0430\u0434\u0430\u0439 \u043A\u043E\u043B\u0456\u0440",
        category: 'game'
    }
];


const $a42e7b9de577ec71$var$gamesContainer = document.querySelector('[data-games]');
const $a42e7b9de577ec71$var$renderGames = (games, container)=>{
    const html = games.reduce((acc, game)=>{
        const gameHTML = `      
    <section id="game-id_${game.id}" class="section">
        <div class="container">
          <div class="game game-id_${game.id}">
          </div>
        </div>
      </section>`;
        acc += gameHTML;
        return acc;
    }, '');
    container.innerHTML = html;
    games.forEach((game)=>{
        if (game.init) game.init();
    });
};
$a42e7b9de577ec71$var$renderGames((0, $5ed35395810c1c9b$export$79863f625c4e57), $a42e7b9de577ec71$var$gamesContainer);
const $a42e7b9de577ec71$var$gamesSections = document.querySelectorAll('.section');
const $a42e7b9de577ec71$var$menuItems = document.querySelectorAll('.menu__item');
const $a42e7b9de577ec71$var$plays = document.querySelectorAll('.menu__text');
const $a42e7b9de577ec71$var$handlePlays = (event)=>{
    const selected = event.currentTarget.dataset.category;
    const filteredGames = (0, $5ed35395810c1c9b$export$79863f625c4e57).filter((game)=>game.category === selected);
    $a42e7b9de577ec71$var$renderGames(filteredGames, $a42e7b9de577ec71$var$gamesContainer);
};
$a42e7b9de577ec71$var$menuItems.forEach((play)=>{
    play.addEventListener('click', $a42e7b9de577ec71$var$handlePlays);
});


const $8aad853c076397e7$var$html = document.querySelector('html');
const $8aad853c076397e7$var$backdropHeader = document.querySelector('.backdrop__header');
const $8aad853c076397e7$var$switcher = document.querySelector('.switcher');
const $8aad853c076397e7$var$helloingSpan = document.querySelector('.helloing__text--part');
const $8aad853c076397e7$var$formInput = document.querySelector('.form__input');
const $8aad853c076397e7$var$helloingUser = document.querySelector('.helloing__text--part');
const $8aad853c076397e7$var$btnSaveModal = document.querySelector('.form__button');
const $8aad853c076397e7$var$secondeBackdropHeader = document.querySelector('.seconde__backdrop__header');
const $8aad853c076397e7$var$btnCloseModal = document.querySelectorAll('.close__button');
const $8aad853c076397e7$var$logoW = document.querySelector('.logo__link_photo--white');
const $8aad853c076397e7$var$logoD = document.querySelector('.logo__link_photo--dark');
const $8aad853c076397e7$var$logoWF = document.querySelector('.footer__logo__link_photo--white');
const $8aad853c076397e7$var$logoDF = document.querySelector('.footer__logo__link_photo--dark');
const $8aad853c076397e7$var$mainGames = document.querySelectorAll(`.game`);
const $8aad853c076397e7$var$form = document.querySelector('.modal__form');
const $8aad853c076397e7$var$modalPhotos = document.querySelector('.modal__photo--seconde');
const $8aad853c076397e7$var$modals = document.querySelector('.modals');
const $8aad853c076397e7$var$interactive = document.querySelector('.menu__interactive');
const $8aad853c076397e7$var$handleSwitcher = (event)=>{
    setTimeout(()=>{
        // взяв з Google
        if (event.target.checked) {
            $8aad853c076397e7$var$html.style.setProperty('--colorBgMain', '#111111');
            $8aad853c076397e7$var$html.style.setProperty('--colorCorrect', '#66FFFF');
            $8aad853c076397e7$var$html.style.setProperty('--colorIncorrect', '#FC66FF');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgPrimary', '#1a1a1a');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgSecondary', '#262626');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgField', '#282828');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgSwitch', '#858585');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgChoose', '#0E0E0E');
            $8aad853c076397e7$var$html.style.setProperty('--colorTextPrimary', '#ffffffb9');
            $8aad853c076397e7$var$html.style.setProperty('--colorTextSecondary', '#818181');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgRPS', '#282828');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgPaginationBullet', '#2d2d2d');
            $8aad853c076397e7$var$logoW.classList.add('dark_logo');
            $8aad853c076397e7$var$logoD.classList.add('dark_logo');
            $8aad853c076397e7$var$logoWF.classList.add('dark_logo');
            $8aad853c076397e7$var$logoDF.classList.add('dark_logo');
            $8aad853c076397e7$var$interactive.classList.add('dark');
        } else {
            $8aad853c076397e7$var$html.style.setProperty('--colorBgMain', '#eeeeee');
            $8aad853c076397e7$var$html.style.setProperty('--colorCorrect', '#039900');
            $8aad853c076397e7$var$html.style.setProperty('--colorIncorrect', '#990000');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgPrimary', '#ffffff');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgSecondary', '#d9d9d9');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgField', '#d7d7d7');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgSwitch', '#7a7a7a');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgChoose', '#f1f1f1');
            $8aad853c076397e7$var$html.style.setProperty('--colorTextPrimary', '#000000');
            $8aad853c076397e7$var$html.style.setProperty('--colorTextSecondary', '#7e7e7e');
            $8aad853c076397e7$var$html.style.setProperty('--colorBgPaginationBullet', '#d9d9d9');
            $8aad853c076397e7$var$logoW.classList.remove('dark_logo');
            $8aad853c076397e7$var$logoD.classList.remove('dark_logo');
            $8aad853c076397e7$var$logoWF.classList.remove('dark_logo');
            $8aad853c076397e7$var$logoDF.classList.remove('dark_logo');
            $8aad853c076397e7$var$interactive.classList.remove('dark');
        }
    }, 250);
};
const $8aad853c076397e7$var$handleHelooing = (event)=>{
    $8aad853c076397e7$var$helloingUser.textContent = event.target.value;
};
const $8aad853c076397e7$var$handleSave = (event)=>{
    event.preventDefault();
    $8aad853c076397e7$var$secondeBackdropHeader.classList.remove('hidden');
};
const $8aad853c076397e7$var$handleClose = (event)=>{
    $8aad853c076397e7$var$modalPhotos.classList.add('hidden');
    $8aad853c076397e7$var$backdropHeader.classList.add('hidden');
    $8aad853c076397e7$var$secondeBackdropHeader.classList.add('hidden');
};
$8aad853c076397e7$var$switcher.addEventListener('change', $8aad853c076397e7$var$handleSwitcher);
$8aad853c076397e7$var$formInput.addEventListener('input', $8aad853c076397e7$var$handleHelooing);
$8aad853c076397e7$var$form.addEventListener('submit', $8aad853c076397e7$var$handleSave);
$8aad853c076397e7$var$btnCloseModal.forEach((btn)=>{
    btn.addEventListener('click', $8aad853c076397e7$var$handleClose);
});


const $a7e561c20ca0346d$var$form = document.querySelector('.footer-form');
const $a7e561c20ca0346d$var$backdrop = document.querySelector('[data-modal]');
const $a7e561c20ca0346d$var$closeBtn = document.querySelector('[data-modal-close]');
console.log("\u0424\u043E\u0440\u043C\u0430:", $a7e561c20ca0346d$var$form);
console.log("\u0411\u0435\u043A\u0434\u0440\u043E\u043F:", $a7e561c20ca0346d$var$backdrop);
console.log("\u041A\u043D\u043E\u043F\u043A\u0430 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F:", $a7e561c20ca0346d$var$closeBtn);
const $a7e561c20ca0346d$var$handleOpenModal = (event)=>{
    event.preventDefault();
    $a7e561c20ca0346d$var$backdrop.classList.remove('is-hidden');
    $a7e561c20ca0346d$var$form.reset();
};
const $a7e561c20ca0346d$var$handleCloseModal = (event)=>{
    event.preventDefault();
    $a7e561c20ca0346d$var$backdrop.classList.add('is-hidden');
};
$a7e561c20ca0346d$var$form.addEventListener('submit', $a7e561c20ca0346d$var$handleOpenModal);
$a7e561c20ca0346d$var$closeBtn.addEventListener('click', $a7e561c20ca0346d$var$handleCloseModal);




//# sourceMappingURL=Magic-coding__Project.fe469de0.js.map
